<div class="topdata-intro">
    <div class="topdata-intro__header">
        <span v-if="isGerman">Topdata Plugins & Services</span>
        <span v-else>Topdata Plugins & Services</span>
    </div>

    <div class="topdata-intro__body">
        <div class="topdata-intro__content">
            <p v-if="isGerman">
                <strong>Topdata</strong> — intelligente Softwarelösungen für Ihren Shopware-Shop.
                Bei Fragen oder Anregungen kontaktieren Sie uns gerne.
            </p>
            <p v-else>
                <strong>Topdata</strong> — intelligent software solutions for your Shopware store.
                Feel free to contact us with any questions or suggestions.
            </p>

            <div class="topdata-intro__buttons">
                <sw-button variant="contrast" :link="resolvedDocUrl">
                    {{ isGerman ? 'Dokumentation' : 'Documentation' }}
                </sw-button>
                <sw-button variant="ghost" link="https://topdata.de">
                    {{ isGerman ? 'Webseite besuchen' : 'Visit website' }}
                </sw-button>
            </div>
        </div>

        <div class="topdata-intro__logo">
            <a href="https://topdata.de" target="_blank" title="Topdata Software GmbH">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 60" role="img" aria-label="Topdata">
                    <rect x="4" y="4" width="52" height="52" rx="8" fill="#0c213b"/>
                    <text x="30" y="40" font-family="Arial, Helvetica, sans-serif" font-size="34" font-weight="bold" fill="#fff" text-anchor="middle">T</text>
                    <text x="68" y="42" font-family="Arial, Helvetica, sans-serif" font-size="28" font-weight="700" fill="#0c213b" letter-spacing="1">topdata</text>
                </svg>
            </a>
        </div>
    </div>
</div>
